export default {
  name: 'NewIntegrations',
  data: function data() {
    return {
      integration_providers: {},
      loading: false,
      fetching: false,
      integration_key: this.$route.query.integration_key,
      integration_info: {},
      settings: {},
      settings_fields: {},
      validating: false
    };
  },
  methods: {
    getIntegrations: function getIntegrations() {
      var _this = this;
      this.loading = true;
      this.$get('integrations/providers').then(function (response) {
        _this.integration_providers = response.providers;
      })["catch"](function (errors) {
        _this.$handleErrors(errors);
      }).always(function () {
        _this.loading = false;
      });
    },
    fetchIntegration: function fetchIntegration() {
      var _this2 = this;
      this.fetching = true;
      this.$get('integrations/providers/' + this.integration_key).then(function (response) {
        _this2.settings = response.settings;
        _this2.settings_fields = response.settings_fields;
        _this2.integration_info = response.info;
      })["catch"](function (errors) {
        _this2.$handleError(errors);
      }).always(function () {
        _this2.fetching = false;
      });
    },
    validateKey: function validateKey() {
      var _this3 = this;
      this.validating = true;
      this.$post('integrations/providers/thrivecart', {
        validate: true,
        api_key: this.settings.api_key
      }).then(function (response) {
        _this3.$notify.success(response.message);
        _this3.$router.push({
          name: 'view_integration',
          params: {
            id: response.integration.id
          }
        });
      })["catch"](function (errors) {
        _this3.$handleError(errors);
      }).always(function () {
        _this3.validating = false;
      });
    }
  },
  mounted: function mounted() {
    // this.getIntegrations();
    // if (this.integration_key) {
    //     this.fetchIntegration();
    // }
  }
};